






import { Component, Vue } from 'vue-property-decorator';
import { app } from '@store/modules/app';
import BasicBanner from '@components/layout/basic-banner.vue';

@Component({
	components: {
		BasicBanner
	}
})
export default class InvestorUpdateBanner extends Vue {
	dismissalKey = 'dismiss-investor-update-banner';

	bannerCta = {
		text: 'Learn more.',
		href: '/investor-update/708/view'
	};

	get showBanner(): boolean {
		return !app.isAuthenticated;
	}
}
